import type { EbizioEventConfig } from '../types';
import { EBIZIO_EVENT_TYPE } from '../types';
import { logger, setActiveStepOnBody } from '../utils';

export const billingStepLoadingConfig: EbizioEventConfig = {
  event: EBIZIO_EVENT_TYPE.BILLING_STEP_LOADING,
  handler: ({ detail }) => {
    logger('Billing Step Loading');
    setActiveStepOnBody(detail.activeStepType);
    console.log(detail);
  },
};
